import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { Trans } from 'react-i18next'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const CompanyStatusForm: FC<FormProps> = props => {
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    setFormData,
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    toggleShowBySecondaryName,
    configData,
  } = useForm(props.fetchedData, config({ countries: dropdownOptions.countries, formType: props.formType }), submitForm)

  useEffect(() => {
    toggleShowByName(
      'nameOfFinancialRegulator',
      formData?.companyRegulatedStatus?.value === 'true'
    )
    toggleShowByName(
      'regulatorAuthorisationNumber',
      formData?.companyRegulatedStatus?.value === 'true'
    )
    toggleShowByName(
      'countryOfRegulator',
      formData?.companyRegulatedStatus?.value === 'true'
    )
    toggleShowByName(
      'regulatorPaymentInstitutionType',
      formData?.companyRegulatedStatus?.value === 'true'
    )
  }, [formData?.companyRegulatedStatus?.value])

  useEffect(() => {
    toggleShowBySecondaryName(
      'listedStockExchangeName',
      formData?.isCompanyListed?.value === 'true' ? 'isCompanyListed-listedStockExchangeName' : formData?.isUBOCompanyListed?.value === 'true' ? 'isUBOCompanyListed-listedStockExchangeName' : ''
    )
    toggleShowBySecondaryName(
      'listingCodeNumber',
      formData?.isCompanyListed?.value === 'true' ? 'isCompanyListed-listingCodeNumber' : formData?.isUBOCompanyListed?.value === 'true' ? 'isUBOCompanyListed-listingCodeNumber' : ''
    )
    toggleShowBySecondaryName(
      'countryOfListedStockExchange',
      formData?.isCompanyListed?.value === 'true' ? 'isCompanyListed-countryOfListedStockExchange' : formData?.isUBOCompanyListed?.value === 'true' ? 'isUBOCompanyListed-countryOfListedStockExchange' : ''
    )
    toggleShowByName(
      'isUBOCompanyListed',
      formData?.isCompanyListed?.value === 'false'
    )

    if((formData?.isCompanyListed?.value === 'false' &&  formData?.isUBOCompanyListed?.value === 'false') || formData?.isUBOCompanyListed?.value === 'false'){
      setFormData(prev => {

        return {
          ...prev,
          listedStockExchangeName: {
            ...prev.listedStockExchangeName,
            value: ''
          },
          listingCodeNumber: {
            ...prev.listingCodeNumber,
            value: ''
          },
          countryOfListedStockExchange: {
            ...prev.countryOfListedStockExchange,
            value: ''
          }
        }
      })
    }
  }, [formData?.isCompanyListed?.value, formData?.isUBOCompanyListed?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.CompanyStatusForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.CompanyStatusForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default CompanyStatusForm
